// extracted by mini-css-extract-plugin
module.exports = {"description":"BatchAddModal_description__zYiU5","inputArea":"BatchAddModal_inputArea__1d8OX","footer":"BatchAddModal_footer__1h7ZS"};